import { ProductEditorInputHelper } from './frame/initProductEditorEvents';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { $delegate } from 'fxdom/es';
import { isDate, isUndefined } from '@fxts/core';
import { SaleEndDateInputField } from '../../../../services/MarppleShop/marppleShopStudioApp/components/cells/ProductEditorField/views/SaleEndDateInputField';
import { SaleStartDateInputField } from '../../../../services/MarppleShop/marppleShopStudioApp/components/cells/ProductEditorField/views/SaleStartDateInputField';
import { onCalendarChangeEvent } from '../../../../services/MarppleShop/renderApp/components/cells/DateInputField/DateInputCalendarController';
import { ProductEditorError } from '../../../../services/MarppleShop/marppleShopStudioApp/components/cells/ProductEditorField/types/type';
import { limited_identifier } from '../../../../services/MarppleShop/marppleShopStudioApp/features/ProductEditor/const/limited';
import { MaxPerUserInputField } from '../../../../services/MarppleShop/marppleShopStudioApp/components/cells/ProductEditorField/views/MaxPerUserInputField';
import { QuantityLimitInputField } from '../../../../services/MarppleShop/marppleShopStudioApp/components/cells/ProductEditorField/views/QuantityLimitInputField';

/**
 * "한정 판매 설정" 체크박스 F event
 */
export const defnLimitedSaleCheckGroupEvent = (
  $tab_el: HTMLElement,
  product_editor_helper: ProductEditorInputHelper,
): HTMLElement => {
  $delegate('change', '[name="limited_sale_type"]', ({ target }: { target: HTMLInputElement }) => {
    const { checked, value } = target;

    const view = (() => {
      if (value === limited_identifier.max_purchase_per_user)
        return product_editor_helper.view.인당구매수량제한;
      if (value === limited_identifier.period) return product_editor_helper.view.판매종료일;
      if (value === limited_identifier.quantity) return product_editor_helper.view.한정판매수량;
    })();

    if (view) {
      view.setVisible(checked);
      view.setRequiredAndSync(checked);
      if (!checked) {
        view.clear();
      }
    }
  })($tab_el);

  return $tab_el;
};

/**
 * 판매 시작일, 판매 종료일 검증하는 F event
 */
export const limitedSaleDateRangeEvent = (
  tab_el: HTMLElement,
  product_editor_helper: ProductEditorInputHelper,
) => {
  // 판매 시작일 검증
  $delegate(onCalendarChangeEvent, `.${SaleStartDateInputField}`, () => {
    const errors = validateSaleDateRange(
      product_editor_helper.view.판매시작일,
      product_editor_helper.view.판매종료일,
    );
    errors.forEach((error) => {
      error.target.setErrorMessage(error.message);
    });
  })(tab_el);

  // 판매 종료일 검증
  $delegate(onCalendarChangeEvent, `.${SaleEndDateInputField}`, () => {
    const errors = validateSaleDateRange(
      product_editor_helper.view.판매시작일,
      product_editor_helper.view.판매종료일,
    );
    errors.forEach((error) => {
      error.target.setErrorMessage(error.message);
    });
  })(tab_el);

  return tab_el;
};

export const quantityMaxPerUser = (
  maxPerUserView?: MaxPerUserInputField,
  quantityLimitView?: QuantityLimitInputField,
): ProductEditorError[] => {
  const max_purchase_per_user = maxPerUserView?.getValue();
  const quantity = quantityLimitView?.getValue()?.quantity;

  if (!isUndefined(max_purchase_per_user) && !isUndefined(quantity) && maxPerUserView) {
    if (quantity < max_purchase_per_user) {
      const error = {
        target: maxPerUserView,
        title: '1인당 구매 가능 수량 확인',
        message: '1인당 구매 가능 수량은 한정 판매 수량보다 같거나 적게 입력해 주세요.',
        detail: '1인당 구매 가능 수량은 한정 판매 수량보다 같거나 적게 입력해 주세요.',
      };
      return [error];
    }
  }
  return [];
};

// 판매 시작일이 종료일보다 이후이면 에러
export const validateSaleDateRange = (
  startDateInputView?: SaleStartDateInputField,
  endDateInputView?: SaleEndDateInputField,
): ProductEditorError[] => {
  const start_date = startDateInputView?.getValue();
  const end_date = endDateInputView?.getValue();

  if (isDate(start_date) && isDate(end_date) && endDateInputView) {
    const valid = start_date.getTime() < end_date.getTime();

    const error = {
      target: endDateInputView,
      title: '판매 종료일 확인',
      message: '종료일은 시작일보다 이후로 설정해야 해요.',
      detail: '종료일은 시작일보다 이후로 설정해야 합니다.\n다시 선택해 주세요.',
    };

    return valid ? [] : [error];
  } else {
    return [];
  }
};
